import OnboardingContainer from '$src/components/OnboardingContainer';
import useLocationContext from '$src/hooks/useLocationContext';
import { redirectToOnboardingRingSolutionsProfessionalMonitoring } from '$src/utils/redirect';
import { handleBackToRingDashboard } from '$src/utils/handleBack';
import useStores from '$src/hooks/useStores';
import { CalloutCard } from '@amzn/ring-react-components/csr/components/CalloutCard';
import { MonitoringSettingsIcon, MonitoringStationIcon } from '@ring-icons';

import SOSImg from '$src/assets/img/sos.png';

import './index.less';

function SOSSetUp() {
  const locationId = useLocationContext();
  const {
    sessionStore: { isMobile },
  } = useStores();

  return (
    <OnboardingContainer
      headerTitle="Monitoring Setup"
      icon={MonitoringSettingsIcon}
      title="Let’s set up SOS for your Ring cameras."
      image={SOSImg}
      className="sos-set-up"
      data-testid="sos-set-up"
      primaryText="Continue"
      handleClose={() => handleBackToRingDashboard(isMobile)}
      hideBack
      primaryActionHandler={() => redirectToOnboardingRingSolutionsProfessionalMonitoring(locationId)}
      warningOnClose
    >
      <CalloutCard icon={<MonitoringStationIcon />} status="default" title={<b>SOS is included as part of your Ring Protect Pro Plan.</b>}>
        To use Virtual Security Guard, please set up SOS.
      </CalloutCard>
      <div className="sos-set-up__text-container--separator">
        <p className="sos-set-up__paragraph-title">What does SOS do?</p>
        <p className="sos-set-up__paragraph-text">
          SOS is a feature that allows you to request help from local authorities with a touch of a button inside the App.
        </p>
      </div>
    </OnboardingContainer>
  );
}
export default SOSSetUp;
